import $ from 'jquery';
import exportBtns from './util/export-buttons';
import services from '@/services/services.service.js';
import { statusColors, fastIcons, serverUrl } from '@/global/variables';

// Feather copy icon (14px)
var copyIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>';
var checkIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';

// Service Options
export const serviceOptions = async () => {
	return [
		{ value: null, text: 'Service' },
		...(await services.fetch('?unactive=1')).map((s) => ({
			text: s.name,
			value: s.name
		}))
	];
};

// Setup Table
export const setupTable = ({ url = '/api/orders', userColumn = false, otherConfig }) => {
	const columns = [
		{ data: 'id', name: "orders.id" },
		{ data: 'status' },
		{ data: 'name', name: "services.name" },
		{ data: 'imei' },
		{ data: 'result' },
		{ data: 'created_at', name: "services.created_at" },
		{ data: 'credit' },
		{ data: 'note' },
		{ data: 'services.category' }
	];
	userColumn && columns.push({ data: 'username', name: "users.username" });

	var $table = $('#vue-datatable');

	var dt = $table.DataTable({
		processing: true,
		serverSide: true,
		responsive: true,
		scrollX: true,
		ajax: {
			url: serverUrl(url),
			beforeSend: function(request) {
				request.setRequestHeader('Authorization', `Bearer ${localStorage.getItem('token')}`);
			}
		},
		buttons: [ ...exportBtns({ 1: 'Status', 2: 'Service' }), 'columnsToggle' ],
		dom: 'Bfrtip',
		pageLength: 50,
		columns: [ ...columns ],
		columnDefs: [
			{
				targets: 0
			},
			{
				targets: 1,
				orderable: false,
				render: function(data) {
					const classesBadge = [ 'badge', `badge-${statusColors[data]}`, 'badge-pill', 'dt-status-badge' ].join(' ');
					return `<span class='${classesBadge}'>${data}</span>`;
				}
			},
			{
				targets: 2,
				orderable: false
			},
			{
				// Result — copy button + word wrap (display only)
				targets: 4,
				orderable: false,
				render: function(data, type) {
					if (type !== 'display') return data || '';
					if (!data) return '<span class="text-muted">—</span>';
					var formatted = data.replace(/\n/g, '<br>');
					return '<div class="dt-result-wrap">' +
						'<span class="dt-copy-btn" title="Copy result">' + copyIcon + '</span>' +
						'<div class="dt-result">' + formatted + '</div>' +
						'</div>';
				}
			},
			{
				// Credit — $ only for display
				targets: 6,
				render: function(data, type) {
					if (!data && data !== 0) return '-';
					var val = parseFloat(data).toFixed(2);
					if (type === 'display') {
						return '<span class="dt-credit">$' + val + '</span>';
					}
					return val;
				}
			},
			{
				targets: 7,
				render: function(data) {
					return data || '<span class="text-muted">No Note</span>';
				}
			},
			{
				visible: false,
				targets: 8
			}
		],
		order: [ [ 0, 'desc' ] ],
		...otherConfig
	});

	// Event delegation for copy button (namespaced to avoid duplicates)
	$table.off('click.dtcopy').on('click.dtcopy', '.dt-copy-btn', function(e) {
		e.stopPropagation();
		var btn = $(this);
		var resultEl = btn.siblings('.dt-result')[0];
		if (!resultEl) return;

		var text = resultEl.innerText;

		navigator.clipboard.writeText(text).then(function() {
			btn.html(checkIcon).addClass('dt-copied');
			setTimeout(function() {
				btn.html(copyIcon).removeClass('dt-copied');
			}, 1500);
		}).catch(function() {
			// Fallback for non-HTTPS
			var ta = document.createElement('textarea');
			ta.value = text;
			ta.style.position = 'fixed';
			ta.style.opacity = '0';
			document.body.appendChild(ta);
			ta.select();
			document.execCommand('copy');
			document.body.removeChild(ta);
			btn.html(checkIcon).addClass('dt-copied');
			setTimeout(function() {
				btn.html(copyIcon).removeClass('dt-copied');
			}, 1500);
		});
	});

	return dt;
};
